"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIntlDateTimeFormat = void 0;
var dateTimeFormatCache = {};
/**
 * Creates and caches Intl.DateTimeFormat instances.
 * @hidden
 * @param options
 */
var getIntlDateTimeFormat = function (options) {
    if (options === void 0) { options = {}; }
    var key = JSON.stringify(options);
    var cachedFormat = dateTimeFormatCache[key];
    if (cachedFormat)
        return cachedFormat;
    var languageTag = options.languageTag, opts = __rest(options, ["languageTag"]);
    var format = Intl.DateTimeFormat(languageTag, __assign({}, opts));
    dateTimeFormatCache[key] = format;
    return format;
};
exports.getIntlDateTimeFormat = getIntlDateTimeFormat;
//# sourceMappingURL=get-intl-date-time-format.js.map